

/// <reference path="StockNoteProductLine.ts" />

// Generated class ProductionNoteLine_ManagedObject

class ProductionNoteLine_ManagedObject extends StockNoteProductLine
{
}
